import { Component, ViewChild, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { DebidaDiligenciaService } from '../../../services/debida-diligencia.service';
import { MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { ReactiveFormsModule,FormControl ,Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormularioItem, Tipo } from 'app/main/models/formulario-item.model';

@Component({
    selector   : 'sentencia-resultado-table',
    templateUrl: './sentencia-resultado-table.component.html',
    styleUrls  : ['./sentencia-resultado-table.component.scss']
})
export class SentenciaResultadoTableComponent
{
  @Input() esMultiple: boolean;
  @Input() debidaDiligenciaEstado:string;
  @Input() sentencia: FormularioItem;
  
  @Output("loadData") loadData: EventEmitter<any> = new EventEmitter();

    opciones =  [];
    displayedColumns: string[] = ['nombre','respuesta'];
    is_eval_owner = false;
    is_admin = false;
    rateControl:FormControl;
    esTextoLibre: boolean;
    esCheckbox: boolean;
    esAdjuntos: boolean;

    debidaDiligenciaId: number;
    debidaDiligenciaUUID: string;
    
    sentenciaStr : string;

    constructor(public translate: TranslateService,
                private _snackBar: MatSnackBar,
                private service: DebidaDiligenciaService,
                private route: ActivatedRoute
                ) {}

    
    ngOnInit() {

      this.route.paramMap.subscribe(params => {
        this.debidaDiligenciaId = parseInt(params.get('id'), 10);
        this.debidaDiligenciaUUID = params.get('uuid');
      });

      /*
      this.sentenciaStr = JSON.stringify(this.sentencia);
      this.rateControl = new FormControl("", [])
      this.esTextoLibre = this.sentencia.tipo === "TEXTO_LIBRE" as Tipo;
      this.esCheckbox = this.sentencia.tipo === "CHECKBOX" as Tipo;
      this.esAdjuntos = this.sentencia.tipo === "ADJUNTO" as Tipo;
      */

      this.loadTypes(this.sentencia);
    
    }

    loadTypes(sentencia):void{
      this.sentenciaStr = JSON.stringify(sentencia);
      this.rateControl = new FormControl("", [])
      this.esTextoLibre = sentencia.tipo === "TEXTO_LIBRE" as Tipo;
      this.esCheckbox = sentencia.tipo === "CHECKBOX" as Tipo;
      this.esAdjuntos = sentencia.tipo === "ADJUNTO" as Tipo;
    }

    descargarArchivo(archivo: any): void {
      // Lógica para descargar el archivo, por ejemplo, abrir una nueva ventana con la URL del archivo
      window.open(archivo.replace("/app/","/"), '_blank');
    }

    saveValue(respuesta):void{
        var error = false;
        this.service.addRespuestaValor(this.debidaDiligenciaUUID,this.sentencia.id,respuesta).pipe().subscribe(req => {
          this.loadData.emit();
        },
        err => {
          this.openSnackBar("No se pudo registrar la respuesta, ocurrió un error.","Cerrar");
        });
    }

    saveCheckboxValue(respuesta):void{
      var error = false;
      this.service.addRespuestaCheckbox(this.debidaDiligenciaUUID,this.sentencia.id,respuesta).pipe().subscribe(req => {
        this.loadData.emit();
      },
      err => {
        this.openSnackBar("No se pudo registrar la respuesta, ocurrió un error.","Cerrar");
      });
  }

    uploadFiles(adjuntos):void{
      var error = false;
      var files = adjuntos.target.files;
      //TODO: ARREGLAR ESTO para que se puedan subir los adjuntos
      this.service.addRespuestaAdjuntos(this.debidaDiligenciaUUID,this.sentencia.id,files).pipe().subscribe(req => {
          this.sentencia.adjuntos = [...req.adjuntos];
          this.loadData.emit();
        },
        err => {
          this.openSnackBar("No se pudieron subir los archivos adjuntos, ocurrió un error.","Cerrar");
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    compareObjects(o1: any, o2: any): boolean {
      var equals = false;
      if(o1!=null && o2!=null)
        equals = o1.nombre === o2.nombre && o1.id === o2.id
      return equals;
    }

    sortComparator(a:any, b:any){
      if ( a.nombre < b.nombre ){
        return 1;
      }
      if ( a.nombre > b.nombre ){
        return -1;
      }
      return 0;
    }



}
